
import { MapLocation } from '@/types/location';

// Fit Factory Gym Locations
export const fitFactoryGyms: MapLocation[] = [
  {
    id: 21001,
    name: "Fit Factory - Riyadh (King Fahd)",
    type: "Gym",
    devices: 4,
    coordinates: [24.747327501813697, 46.6682733397623],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
